import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'

import { FORM_MODIFICACION_CUBICAJE_SILOS } from '../../../config/forms'
import { OperacionesModificacionCubicajeSiloDialogView } from '../components/OperacionesModificacionCubicajeSiloDialogView'

class OperacionesModificacionCubicajeSiloDialog extends Component {
  render () {
    const { silo } = this.props
    return (
      <OperacionesModificacionCubicajeSiloDialogView
        silo={silo}
      />
    )
  }
}

const mapStateToProps = state => {
  return {
    silo: state.movimientoSilos.siloOperando
  }
}
export default connect(mapStateToProps)(reduxForm({
  form: FORM_MODIFICACION_CUBICAJE_SILOS,
  initialValues: {},
  enableReinitialize: true
})(OperacionesModificacionCubicajeSiloDialog))
